export default __webpack_public_path__ + "static/media/placeholder_dummy2016-meditation01-de.1633540e.png";